import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import FlexBox from '../../../../components/shared/flexbox';
import { SettingUrls } from '../../../../constants/SettingsUrls';
import { WizardStepName } from '../../../../data/ppoints/constants';
import { useAppDispatch } from '../../../../redux/hooks';
import { wizardActions } from '../../../../redux/slices/wizard-slice';
import useWizard from '../../hooks/useWizard';

export const SummaryStep: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const wizard = useWizard();
    const { currentSubscription } = useCurrentSubscriptionHelper();

    const handleOpenOwnStep = () => {
        navigate(SettingUrls.billing);
        dispatch(wizardActions.setSelectedStepName(WizardStepName.summary));
    };
    const handleNext = async () => {
        await wizard.markStepDone(WizardStepName.summary);
        navigate(SettingUrls.dashboard);
        // dispatch(wizardActions.setSelectedStepName(WizardStepName.summary));
    };

    const hasActiveSubscription = useMemo(() => !!currentSubscription, [currentSubscription]);

    const openOwnStepButton = (
        <div className="inline-flex items-center gap-2">
            <s-button variant="primary" onClick={handleOpenOwnStep}>
                {t('WIZARD.SUMMARY_STEP.BUTTON')}
            </s-button>
            {!hasActiveSubscription && (
                <div>
                    <s-badge tone="info" icon="confetti">
                        {/* <div className="inline-flex items-center justify-center gap-1"> */}
                        {/* <s-icon type="confetti" size="small" /> */}
                        <span dangerouslySetInnerHTML={{ __html: t('WIZARD.SUMMARY_STEP.BUTTON_PROMO_TEXT') }} />
                        {/* </div> */}
                    </s-badge>
                </div>
            )}
        </div>
    );
    const nextButton = (
        <s-button variant="primary" onClick={handleNext} inlineSize="fill">
            {t('BUTTON.NEXT')}
        </s-button>
    );

    const buttonToShow: React.ReactNode | null = useMemo(() => {
        if (!location.pathname.startsWith(SettingUrls.billing)) {
            return openOwnStepButton;
        }
        if (hasActiveSubscription) {
            return nextButton; // show next button if ecom has active subscription
        }
        return null;
    }, [hasActiveSubscription, openOwnStepButton, nextButton]);

    return (
        <FlexBox width={'100%'} gap={12} padding={'10px 0 10px 0'}>
            <FlexBox gap={10} flexDirection={'column'}>
                <div dangerouslySetInnerHTML={{ __html: t('WIZARD.SUMMARY_STEP.DESCRIPTION') }} />
                <div>{buttonToShow}</div>
            </FlexBox>
        </FlexBox>
    );
};
